import React, { Component } from 'react';
import { t } from 'ttag';
import ArrowSvg from './ArrowSvg';
import IconRemove from '../../../sharedSvgs/IconRemove';

class BreadcrumbsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      arrowFlip: false,
      showArr: false
    };
  }

  componentDidMount() {
    if (this.props.breadcrumbs && this.props.breadcrumbs.length > 0) {
      window.ua(
        'trackStructEvent',
        'breadcrumbs',
        'breadcrumb_display',
        this.props.position,
        this.props.breadcrumbs.length
      );

      let totalWidth = 0;
      document.querySelectorAll('.bcItem').forEach(item => {
        const style = item.currentStyle || window.getComputedStyle(item);
        totalWidth += item.offsetWidth + parseFloat(style.marginRight);
      });
      const holderEl = document.querySelector('.crumbItems');
      const visibleWidth = this.props.twoRows
        ? holderEl.offsetWidth * 2
        : holderEl.offsetWidth;
      if (totalWidth > visibleWidth) {
        this.setState({
          showArr: true
        });
      }
    }

    // Hack to reduce the bottom-margin of the category header when tags appear.
    const headerEl = document.querySelector('.category-header');
    if (headerEl) {
      headerEl.style.marginBottom = '10px';
    }
  }

  clickHandler = () => {
    this.setState(prevState => {
      return {
        expanded: !prevState.expanded,
        arrowFlip: !prevState.arrowFlip
      };
    });
  };

  handleTagClick = id => {
    window.ua(
      'trackStructEvent',
      'breadcrumbs',
      'breadcrumb_click',
      this.props.position,
      id
    );
  };

  hasBcValue = crumb => {
    if (crumb.name && crumb.name.length > 0) return true;
    if (crumb.title && crumb.title.length > 0) return true;
    return false;
  };

  renderCrumbs = () => {
    const { breadcrumbs, position } = this.props;
    if (breadcrumbs.length > 0) {
      return (
        <div className="crumbItems">
          {breadcrumbs.map((item, i) => {
            if (position === 'category' && item.static_link) return null;
            if (this.hasBcValue(item)) {
              const name = item.name || item.title;
              return (
                <div key={name} className="bcItem">
                  <a
                    className="crumbItems"
                    style={{ color: '#737373' }}
                    href={item.url || `/${item.slug}`}
                    onClick={() => this.handleTagClick(item.base_item_id)}
                  >
                    {i === 0 ? (
                      <div className="bcItemName">{name}</div>
                    ) : (
                      <div className="bcItemName">{name}</div>
                    )}
                  </a>
                </div>
              );
            }
            return null;
          })}
        </div>
      );
    }
    return null;
  };

  renderSeeMore(position, breadcrumbs) {
    if (position === 'bottom' && this.props.breadcrumbs.length > 0) {
      return <div className="subHeader">{t`See more`}:</div>;
    }
    if (breadcrumbs.length < 1) {
      return null;
    }
    return null;
  }

  render() {
    // const expanded = window.innerWidth >= 1024 ? 'expanded' : '';
    const classes = ['wrapper_list'];
    if (this.props.twoRows) {
      classes.push('wrapper_list--two_rows');
    }
    if (this.state.expanded || !this.props.expandable) {
      classes.push('wrapper_list--expanded');
    }
    const arrowFlip = this.state.arrowFlip ? 'arrow_flip' : 'arrow_down';

    return (
      this.props.breadcrumbs.length > 0 && (
        <div className="breadcrumbs_new">
          <div
            className="close_top"
            aria-label={t`Close`}
            role="button"
            tabIndex="0"
            onClick={this.clickHandler}
          >
            {this.props.expandable &&
              this.state.showArr &&
              arrowFlip !== 'arrow_down' && (
                <span
                  className={`close_top__icon ${
                    this.props.sidePadding ? 'close_top__icon--margin' : ''
                  }`}
                >
                  <IconRemove />
                </span>
              )}
          </div>
          {!this.props.expandable &&
            this.renderSeeMore(this.props.position, this.props.breadcrumbs)}
          <div className={classes.join(' ')}>
            <nav className="crumbs">
              <div
                className={`crumb-content ${
                  this.props.sidePadding ? 'crumb-content--padding' : ''
                }`}
              >
                {this.renderCrumbs()}
              </div>
            </nav>
          </div>
          {this.props.expandable && this.state.showArr && (
            <div
              className="cta"
              role="button"
              tabIndex="0"
              onClick={this.clickHandler}
            >
              <span className={`arrow ${arrowFlip}`}>
                <ArrowSvg />
              </span>
              <span className="cta_text">
                {arrowFlip === 'arrow_down' ? t`Show categories` : t`Close`}
              </span>
            </div>
          )}
        </div>
      )
    );
  }
}

export default BreadcrumbsList;
